@if (displayActionsAsIcons.value === true) {
<mat-card appearance="outlined" data-tfa="toolbox-component_card" id="toolbox_card">
    <mat-card-content id="toolbox-content">
        <h1 id="toolbox-title">Editeur</h1>
        <div class="toolbox_group">
            <button
                data-tfa="bouton-retour"
                mat-mini-fab
                matTooltip="Annuler la dernière modification"
                [disabled]="!history.canUndo()"
                (click)="history.undo()"
            >
                <mat-icon data-tfa="Annuler la dernière modification">undo</mat-icon>
            </button>
            <button data-tfa="bouton-rétablir" mat-mini-fab matTooltip="Rétablir" [disabled]="!history.canRedo()" (click)="history.redo()">
                <mat-icon data-tfa="Rétablir">redo</mat-icon>
            </button>
        </div>
        <div class="toolbox_group">
            <button
                data-tfa="bouton-créer"
                mat-mini-fab
                [matTooltip]="'Créer'"
                [appEnableIfAutorise]="ODF_CREER_OBJET_MAQUETTE"
                [disabled]="(espaceActuel$ | async) === null"
                (click)="onCreerObjetMaquette()"
            >
                <mat-icon data-tfa="add">add</mat-icon>
            </button>
            <button
                data-tfa="bouton-copier-vers"
                mat-mini-fab
                [matTooltip]="'Copier vers un espace de travail'"
                (click)="openImportDialog()"
                [appEnableIfAutorise]="ODF_COPIER_MAQUETTE_EXISTANT_VERS_ESPACE"
                [disabled]="!canOpenImportDialog()"
            >
                <mat-icon data-tfa="send">content_copy</mat-icon>
            </button>
            <button
                data-tfa="bouton-export"
                [appEnableIfAutorise]="ODF_EXPORTER_MAQUETTE"
                mat-mini-fab
                [matTooltip]="'Exporter la maquette'"
                (click)="share()"
                [disabled]="!canShare()"
            >
                <mat-icon data-tfa="send">file_download</mat-icon>
            </button>
            <button
                data-tfa="bouton-verifier-nomenclatures"
                mat-mini-fab
                matTooltip="Vérifier les nomenclatures et paramétrages à la date de début de période"
                (click)="verifierNomenclatures()"
                [disabled]="(racine$ | async) === null"
            >
                <mat-icon data-tfa="icon-verifier-nomenclatures">library_add_check</mat-icon>
            </button>
            <button
                data-tfa="bouton-copier-formations-porteuses"
                mat-mini-fab
                matTooltip="Récupérer les formations porteuses depuis un espace source"
                (click)="openRecupererFormationsPorteusesDialog()"
                [disabled]="(racine$ | async) === null"
            >
                <mat-icon data-tfa="icon-copier-formations-porteuses">content_paste_go</mat-icon>
            </button>
        </div>
        <div class="toolbox_group">
            <button data-tfa="bouton-déplier" mat-mini-fab [matTooltip]="'Déplier tout'" (click)="doExpandTree()">
                <mat-icon data-tfa="unfold">unfold_more</mat-icon>
            </button>
            <button data-tfa="bouton-plier" mat-mini-fab [matTooltip]="'Replier tout'" (click)="doCollapseTree()">
                <mat-icon data-tfa="fold">unfold_less</mat-icon>
            </button>
        </div>
        <div class="toolbox-group" class="margin-left-auto">
            @if (filtresPartiesArbre$ | async; as filtres) {
            <div class="filtre-arbre-group">
                <mat-checkbox
                    data-tfa="checkbox-partie-haute"
                    matTooltip="afficher la partie haute (administrative) de la maquette"
                    [checked]="filtres.partieHaute"
                    [value]="'partieHaute'"
                    (change)="changeFiltrePartieArbre($event)"
                    >Partie administrative</mat-checkbox
                >
                <mat-checkbox
                    data-tfa="checkbox-partie-basse"
                    matTooltip="afficher la partie basse (pédagogique) de la maquette"
                    [checked]="filtres.partieBasse"
                    [value]="'partieBasse'"
                    (change)="changeFiltrePartieArbre($event)"
                    >Partie pédagogique</mat-checkbox
                >
            </div>
            }
        </div>
        <div class="toolbox_group">
            <mat-form-field subscriptSizing="dynamic">
                <mat-label>Identifier par code ou libellé</mat-label>
                <input
                    type="text"
                    matInput
                    data-tfa="input-filtre-texte"
                    [formControl]="textFilter"
                    (keyup.enter)="$event.stopImmediatePropagation(); filtrerParTexte()"
                />
                @if (textFilter.value) {
                <button
                    data-tfa="cancel-button"
                    id="filtre-cancel-button"
                    mat-mini-fab
                    matSuffix
                    matTooltip="annuler la recherche"
                    (click)="resetText()"
                >
                    <mat-icon data-tfa="icon-cancel">close</mat-icon>
                </button>
                } @if (textFilter.value && (rechercheActuelleResultsCount$ | async); as count) {
                <mat-hint id="filtrage-resultats-count">
                    @if (count.index !== null && count.index !== undefined) { résultat {{ count.totalElements ? count.index! + 1 : 0 }} /
                    {{ count.totalElements }}
                    }
                </mat-hint>
                }
            </mat-form-field>
        </div>
        <div class="toolbox-group" class="margin-left-auto">
            @if (viewLayout$ | async; as viewLayout) {
            <div class="filtre-arbre-group">
                <mat-checkbox data-tfa="tabs-layout" [checked]="sidebarOpened$ | async" (change)="toggleSideBar()"
                    >Détail et Biblio.</mat-checkbox
                >
            </div>
            }
        </div>
        <div class="toolbox-group">
            <div class="filtre-arbre-group">
                <mat-checkbox data-tfa="barre-outils-a-icones-checkbox" [formControl]="displayActionsAsIcons"
                    >Barre d'outils à icônes</mat-checkbox
                >
            </div>
        </div>
    </mat-card-content>
</mat-card>
} @else {
<mat-card appearance="outlined" data-tfa="toolbox-component_card" id="toolbox" class="not-classic">
    <mat-card-content id="toolbox-content">
        <h1>Editeur</h1>
        <button data-tfa="file-menu-button-fichier" mat-button [mat-menu-trigger-for]="menuFichier">Fichier</button>
        <mat-menu #menuFichier="matMenu">
            <button
                mat-menu-item
                data-tfa="menu-item_button-nouveau"
                [appEnableIfAutorise]="ODF_CREER_OBJET_MAQUETTE"
                [disabled]="(espaceActuel$ | async) === null"
                (click)="onCreerObjetMaquette()"
            >
                Nouveau<mat-icon color="accent" data-tfa="add">add</mat-icon>
            </button>
            <button mat-menu-item data-tfa="menu-item_button-copier-vers" (click)="openImportDialog()" [disabled]="!canOpenImportDialog()">
                Copier vers un espace de travail<mat-icon color="accent" data-tfa="send">content_copy</mat-icon>
            </button>
            <button mat-menu-item data-tfa="menu-item_button-exporter" (click)="share()" [disabled]="!canShare()">
                Exporter la maquette<mat-icon color="accent" data-tfa="send">file_upload</mat-icon>
            </button>
        </mat-menu>
        <button data-tfa="file-menu-button-edition" mat-button [mat-menu-trigger-for]="menuEdition">Edition</button>
        <mat-menu #menuEdition="matMenu">
            <button mat-menu-item data-tfa="menu-item_button-annuler" [disabled]="!history.canUndo()" (click)="history.undo()">
                Annuler<mat-icon color="accent" data-tfa="Annuler">undo</mat-icon>
            </button>
            <button mat-menu-item data-tfa="menu-item_button-retablir" [disabled]="!history.canRedo()" (click)="history.redo()">
                Rétablir<mat-icon color="accent" data-tfa="Rétablir">redo</mat-icon>
            </button>
        </mat-menu>
        <button data-tfa="file-menu-button-affichage" mat-button [mat-menu-trigger-for]="menuAffichage">Affichage</button>
        <mat-menu #menuAffichage="matMenu">
            <button mat-menu-item data-tfa="menu-item_button-deplier" (click)="doExpandTree()">
                Déplier tout<mat-icon color="accent" data-tfa="unfold">unfold_more</mat-icon>
            </button>
            <button mat-menu-item data-tfa="menu-item_button-replier" (click)="doCollapseTree()">
                Replier tout<mat-icon color="accent" data-tfa="fold">unfold_less</mat-icon>
            </button>
            <mat-divider></mat-divider>
            <button mat-menu-item data-tfa="menu-item_button-partie-admin" (click)="changeFiltrePartieArbreDirect('partieHaute')">
                Afficher la partie administrative @if ((filtresPartiesArbre$ | async)?.partieHaute) {
                <mat-icon data-tfa="icon-check" color="accent">check</mat-icon>
                }
            </button>
            <button mat-menu-item data-tfa="menu-item_button-partie-péda" (click)="changeFiltrePartieArbreDirect('partieBasse')">
                Afficher la partie pédagogique @if ((filtresPartiesArbre$ | async)?.partieBasse) {
                <mat-icon data-tfa="icon-check" color="accent">check</mat-icon>
                }
            </button>
            <mat-divider></mat-divider>
            <button mat-menu-item data-tfa="menu-item_button-details-et-biblio" (click)="toggleSideBar()">
                Afficher les détails et la biblio @if (sidebarOpened$ | async) {
                <mat-icon data-tfa="icon-check" color="accent">check</mat-icon>
                }
            </button>
            <!-- <button mat-menu-item data-tfa="menu-item_button-graph" (click)="toggleViewLayout()">
              Afficher la vue graphique
              <mat-icon data-tfa="icon-check" color="accent" *ngIf="(viewLayout$ | async) === 'graph'">check</mat-icon>
            </button> -->
            <button mat-menu-item data-tfa="menu-item_button-vue classique" (click)="displayActionsAsIcons.setValue(true)">
                Afficher la barre d'outils à icônes
            </button>
        </mat-menu>
        <mat-form-field subscriptSizing="dynamic" [appearance]="'outline'">
            <mat-label>Rechercher</mat-label>
            <input
                type="text"
                matInput
                data-tfa="input-filtre-texte"
                [formControl]="textFilter"
                (keyup.enter)="$event.stopImmediatePropagation(); filtrerParTexte()"
            />
            @if (textFilter.value) {
            <button
                data-tfa="cancel-button"
                id="filtre-cancel-button"
                mat-mini-fab
                matSuffix
                matTooltip="annuler la recherche"
                (click)="resetText()"
            >
                <mat-icon data-tfa="icon-cancel">close</mat-icon>
            </button>
            } @if (textFilter.value && (rechercheActuelleResultsCount$ | async); as count) {
            <mat-hint>
                @if (count.index !== null && count.index !== undefined) { résultat {{ count.totalElements ? count.index! + 1 : 0 }} /
                {{ count.totalElements }}
                }
            </mat-hint>
            }
        </mat-form-field>
    </mat-card-content>
</mat-card>
}

<ng-template #vueClassique>
    <mat-card appearance="outlined" data-tfa="toolbox-component_card" id="toolbox" class="not-classic">
        <mat-card-content id="toolbox-content">
            <h1>Editeur</h1>
            <button data-tfa="file-menu-button-fichier" mat-button [mat-menu-trigger-for]="menuFichier">Fichier</button>
            <mat-menu #menuFichier="matMenu">
                <button
                    mat-menu-item
                    data-tfa="menu-item_button-nouveau"
                    [appEnableIfAutorise]="ODF_CREER_OBJET_MAQUETTE"
                    [disabled]="(espaceActuel$ | async) === null"
                    (click)="onCreerObjetMaquette()"
                >
                    Nouveau<mat-icon color="accent" data-tfa="add">add</mat-icon>
                </button>
                <button
                    mat-menu-item
                    data-tfa="menu-item_button-copier-vers"
                    (click)="openImportDialog()"
                    [disabled]="!canOpenImportDialog()"
                >
                    Copier vers un espace de travail<mat-icon color="accent" data-tfa="send">content_copy</mat-icon>
                </button>
                <button mat-menu-item data-tfa="menu-item_button-exporter" (click)="share()" [disabled]="!canShare()">
                    Exporter la maquette<mat-icon color="accent" data-tfa="send">file_upload</mat-icon>
                </button>
            </mat-menu>
            <button data-tfa="file-menu-button-edition" mat-button [mat-menu-trigger-for]="menuEdition">Edition</button>
            <mat-menu #menuEdition="matMenu">
                <button mat-menu-item data-tfa="menu-item_button-annuler" [disabled]="!history.canUndo()" (click)="history.undo()">
                    Annuler<mat-icon color="accent" data-tfa="Annuler">undo</mat-icon>
                </button>
                <button mat-menu-item data-tfa="menu-item_button-retablir" [disabled]="!history.canRedo()" (click)="history.redo()">
                    Rétablir<mat-icon color="accent" data-tfa="Rétablir">redo</mat-icon>
                </button>
            </mat-menu>
            <button data-tfa="file-menu-button-affichage" mat-button [mat-menu-trigger-for]="menuAffichage">Affichage</button>
            <mat-menu #menuAffichage="matMenu">
                <button mat-menu-item data-tfa="menu-item_button-deplier" (click)="doExpandTree()">
                    Déplier tout<mat-icon color="accent" data-tfa="unfold">unfold_more</mat-icon>
                </button>
                <button mat-menu-item data-tfa="menu-item_button-replier" (click)="doCollapseTree()">
                    Replier tout<mat-icon color="accent" data-tfa="fold">unfold_less</mat-icon>
                </button>
                <mat-divider></mat-divider>
                <button mat-menu-item data-tfa="menu-item_button-partie-admin" (click)="changeFiltrePartieArbreDirect('partieHaute')">
                    Afficher la partie administrative @if ((filtresPartiesArbre$ | async)?.partieHaute) {
                    <mat-icon data-tfa="icon-check" color="accent">check</mat-icon>
                    }
                </button>
                <button mat-menu-item data-tfa="menu-item_button-partie-péda" (click)="changeFiltrePartieArbreDirect('partieBasse')">
                    Afficher la partie pédagogique @if ((filtresPartiesArbre$ | async)?.partieBasse) {
                    <mat-icon data-tfa="icon-check" color="accent">check</mat-icon>
                    }
                </button>
                <mat-divider></mat-divider>
                <button mat-menu-item data-tfa="menu-item_button-details-et-biblio" (click)="toggleSideBar()">
                    Afficher les détails et la biblio @if (sidebarOpened$ | async) {
                    <mat-icon data-tfa="icon-check" color="accent">check</mat-icon>
                    }
                </button>
                <!-- <button mat-menu-item data-tfa="menu-item_button-graph" (click)="toggleViewLayout()">
            Afficher la vue graphique
            <mat-icon data-tfa="icon-check" color="accent" *ngIf="(viewLayout$ | async) === 'graph'">check</mat-icon>
          </button> -->
                <button mat-menu-item data-tfa="menu-item_button-vue classique" (click)="displayActionsAsIcons.setValue(true)">
                    Afficher la barre d'outils à icônes
                </button>
            </mat-menu>
            <mat-form-field subscriptSizing="dynamic" [appearance]="'outline'">
                <mat-label>Rechercher</mat-label>
                <input
                    type="text"
                    matInput
                    data-tfa="input-filtre-texte"
                    [formControl]="textFilter"
                    (keyup.enter)="$event.stopImmediatePropagation(); filtrerParTexte()"
                />
                @if (textFilter.value) {
                <button
                    data-tfa="cancel-button"
                    id="filtre-cancel-button"
                    mat-mini-fab
                    matSuffix
                    matTooltip="annuler la recherche"
                    (click)="resetText()"
                >
                    <mat-icon data-tfa="icon-cancel">close</mat-icon>
                </button>
                } @if (textFilter.value && (rechercheActuelleResultsCount$ | async); as count) {
                <mat-hint>
                    @if (count.index !== null && count.index !== undefined) { résultat {{ count.totalElements ? count.index! + 1 : 0 }} /
                    {{ count.totalElements }}
                    }
                </mat-hint>
                }
            </mat-form-field>
        </mat-card-content>
    </mat-card>
</ng-template>

<ng-template #importerDialogTemplate>
    <p>
        Vous vous apprêtez à copier une maquette vers un autre espace. Veuillez sélectionner l'espace de destination.<br />
        <lib-pegase-message-contextuel
            data-tfa="alert-copier-vers-espace"
            [type]="'alert'"
            [message]="
                'Si un objet dans l\'espace actuel est déjà présent dans l\'espace de destination (car ils ont le même code), l\'objet déjà présent dans l\'espace de destination sera utilisé dans la maquette qui est copiée.'
            "
            [closable]="false"
        ></lib-pegase-message-contextuel>
    </p>
    <p class="text-base">* Champs obligatoires</p>
    <form id="import-form" data-tfa="import-form" [formGroup]="copierVersForm">
        @if (espaceActuel$ | async; as espaceActuel) {
        <mat-card data-tfa="card-espace-actuel" id="card-espace-actuel">
            <mat-card-title>Espace actuel :</mat-card-title>
            {{ espaceActuel.code }} - {{ espaceActuel.libelle }}
            <app-espace-chip [espace]="espaceActuel"></app-espace-chip>
        </mat-card>
        }
        <mat-icon aria-hidden="true" data-tfa="icone-flèche">arrow_forward</mat-icon>
        <mat-card data-tfa="card-espace-destination" id="card-espace-destination">
            <mat-card-title>Espace de destination :</mat-card-title>
            <app-espace-selector
                (espaceSelected)="patchCopierMaquetteVersEspaceForm($event)"
                [propageSelection]="false"
                [required]="true"
                [style]="{ 'align-self': 'center' }"
                [espaceActuelAutorise]="false"
            ></app-espace-selector>
        </mat-card>
    </form>
    <mat-divider></mat-divider>
    <div class="bottom-buttons">
        @if (loading$ | async) {
        <button mat-raised-button data-tfa="import-bouton-enregistrer" color="primary" [disabled]="true">
            Import en cours
        </button>
        <mat-spinner color="accent" diameter="20" mode="indeterminate"></mat-spinner>
        } @else {
        <button
            mat-raised-button
            data-tfa="import-bouton-enregistrer"
            color="primary"
            [disabled]="copierVersForm.invalid"
            (click)="submitCopierVersEspace()"
        >
            <mat-icon data-tfa="icone-envoyer">send</mat-icon>
            Copier
        </button>
        }
        <ng-template #submitButton>
            <button
                mat-raised-button
                data-tfa="import-bouton-enregistrer"
                color="primary"
                [disabled]="copierVersForm.invalid"
                (click)="submitCopierVersEspace()"
            >
                <mat-icon data-tfa="icone-envoyer">send</mat-icon>
                Copier
            </button>
        </ng-template>
    </div>
</ng-template>

<ng-template #importSuccessNotificationTemplate>
    <p>
        La maquette qui a pour racine {{ objetMaquetteImporte.code }} a bien été importée dans l'espace
        {{ this.copierVersForm.controls.espace.value?.code }}.
    </p>
    <p>
        <a [routerLink]="'../' + objetMaquetteImporte.id" data-tfa="lien-ouvrir">Ouvrir</a>
    </p>
</ng-template>

<ng-template #nomenclaturesErreursTpl>
    @if (erreursNomenclatures) {
    <table
        data-tfa="nomenclatures-erreurs-table"
        mat-table
        class="table-container"
        [dataSource]="erreursNomenclatures!"
        tabindex="0"
        aria-labelledby="toolbox-title"
    >
        <!-- CODE -->
        <ng-container matColumnDef="codeObjetMaquette" role="row">
            <th tabindex="0" mat-header-cell *matHeaderCellDef scope="col" role="columnheader" data-tfa="header-cell_codeObjetMaquette">
                Code Objet maquette
            </th>
            <td
                tabindex="0"
                mat-cell
                *matCellDef="let element; let i = dataIndex"
                role="cell"
                class="action codeObjetMaquette"
                [attr.data-tfa]="'codeObjetMaquette-' + element.code"
            >
                {{ element.codeObjetMaquette }}
            </td>
        </ng-container>
        <ng-container matColumnDef="type" role="row">
            <th tabindex="0" mat-header-cell *matHeaderCellDef scope="col" role="columnheader" data-tfa="header-cell_type">
                type nomenclature
            </th>
            <td
                tabindex="0"
                mat-cell
                *matCellDef="let element; let i = dataIndex"
                role="cell"
                class="action type"
                [attr.data-tfa]="'type-' + element.code"
            >
                @if (!isOptionalRow(i, element)) {
                {{ element.nomenclatureList[0].type }}
                }
            </td>
        </ng-container>
        <ng-container matColumnDef="typeNomenclature" role="row">
            <th tabindex="0" mat-header-cell *matHeaderCellDef scope="col" role="columnheader" data-tfa="header-cell_type">
                code nomenclature
            </th>
            <td
                tabindex="0"
                mat-cell
                *matCellDef="let element; let i = dataIndex"
                role="cell"
                class="action typeNomenclature"
                [attr.data-tfa]="'typeNomenclature-' + element.code"
                style="text-align: end;"
            >
                @if (!isOptionalRow(i, element)) {
                {{ element.nomenclatureList[0].code }}
                }
            </td>
        </ng-container>
        <ng-container matColumnDef="message" role="row">
            <th tabindex="0" mat-header-cell *matHeaderCellDef scope="col" role="columnheader" data-tfa="header-cell_message">message</th>
            <td
                tabindex="0"
                mat-cell
                *matCellDef="let element; let i = dataIndex"
                role="cell"
                class="action expanded-detail message"
                [attr.data-tfa]="'message-' + element.code"
                style="text-align: end;"
            >
                @if (element.nomenclatureList && element.nomenclatureList.length > 0) {
                <div class="errors-container" style="display:flex;">
                    @for (detail of element.nomenclatureList; track detail) {
                    <div class="individual-error">Valeur invalide</div>
                    }
                </div>
                }
            </td>
        </ng-container>
        <!-- EXPANDED CONTEXTS COLUMN -->
        <ng-container matColumnDef="expandedDetails">
            <td
                tabindex="0"
                mat-cell
                *matCellDef="let element; let i = dataIndex"
                [attr.colspan]="'2'"
                class="expanded-detail"
                style="overflow: hidden;"
                [attr.data-tfa]="'cell-expanded-contexts-' + element.code"
            >
                @if (element.nomenclatureList && element.nomenclatureList.length > 1) {
                <div class="errors-container" style="display:flex;">
                    @for (detail of element.nomenclatureList; track detail) {
                    <div class="individual-error" style="padding:0;">
                        <span class="type">{{ detail.type }}</span>
                        <span class="code" style="text-align: end;">{{ detail.code }}</span>
                    </div>
                    }
                </div>
                }
            </td>
        </ng-container>
        <tr
            mat-row
            *matRowDef="
                let element;
                let index = dataIndex;
                columns: ['codeObjetMaquette', 'type', 'typeNomenclature', 'message'];
                when: !isOptionalRow
            "
            [ngClass]="{ 'grey-row': index % 2 !== 0 }"
            data-tfa="normal-row"
            (click)="toggleRowExpansion(element)"
        ></tr>
        <!-- expandable row -->
        <tr
            mat-row
            *matRowDef="
                let element;
                let index = dataIndex;
                columns: ['codeObjetMaquette', 'expandedDetails', 'message'];
                when: isOptionalRow
            "
            class="expansion-row"
            [class.expanded]="isExpandedRow(element)"
            [ngClass]="{ 'grey-row': index % 2 !== 0 }"
            data-tfa="expandable-row"
        ></tr>
        <tr mat-header-row *matHeaderRowDef="['codeObjetMaquette', 'type', 'typeNomenclature', 'message']" data-tfa="header-row"></tr>
    </table>

    }

    <mat-card-actions>
        <button data-tfa="télécharger-résultats-button" mat-raised-button color="accent" (click)="downloadErreursNomenclaturesAsCSV()">
            <mat-icon data-tfa="icon-download">download</mat-icon>
            Télécharger sous forme de fichier
        </button>
    </mat-card-actions>
</ng-template>

<ng-template #recupererFormationsPorteusesTemplate>
    <p>
        Vous vous apprêtez à récupérer les formations porteuses de la maquette depuis un autre espace.<br />
        <lib-pegase-message-contextuel
            data-tfa="alert-copier-vers-espace"
            [type]="'alert'"
            [message]="
                'Si une formation porteuse est déjà associée à un objet dans l\'espace actuel, la formation porteuse associée dans l\'espace source sera ignorée, et la formation porteuse déjà associée sera conservée.'
            "
            [closable]="false"
        ></lib-pegase-message-contextuel>
    </p>
    <form
        id="recupererformations-porteuses-form"
        data-tfa="recupererformations-porteuses-form"
        [formGroup]="recupererFormationsPorteusesForm"
    >
        <p class="text-base">* Champs obligatoires</p>
        <mat-card data-tfa="card-espace-destination" id="card-espace-destination">
            <mat-card-title>Récupérer depuis <span class="no-wrap">l'espace :</span></mat-card-title>
            <app-espace-selector
                (espaceSelected)="patchRecupererFormationsPorteusesForm($event)"
                [propageSelection]="false"
                [useActualEspace]="false"
                [style]="{ 'align-self': 'center' }"
                [espaceActuelAutorise]="false"
                [required]="true"
            ></app-espace-selector>
        </mat-card>
        <mat-icon aria-hidden="true" data-tfa="icone-flèche">arrow_forward</mat-icon>
        @if (espaceActuel$ | async; as espaceActuel) {
        <mat-card data-tfa="card-espace-actuel" id="card-espace-actuel">
            <mat-card-title>Appliquer dans l'espace <span class="no-wrap">actuel :</span></mat-card-title>
            {{ espaceActuel.code }} - {{ espaceActuel.libelle }}
            <app-espace-chip [espace]="espaceActuel"></app-espace-chip>
        </mat-card>
        }
    </form>
    <mat-divider></mat-divider>
    <div class="bottom-buttons">
        @if (loading$ | async) {
        <button mat-raised-button data-tfa="recupererformations-porteuses-bouton-enregistrer" color="primary" [disabled]="true">
            Récupération en cours
        </button>
        <mat-spinner color="accent" diameter="20" mode="indeterminate"></mat-spinner>
        } @else {
        <button
            mat-raised-button
            data-tfa="recupererformations-porteuses-bouton-annuler"
            color="accent"
            (click)="closeRecupererFormationsPorteusesDialog()"
        >
            Annuler
            <mat-icon iconPositionEnd data-tfa="icone-annuler">close</mat-icon>
        </button>
        <button
            mat-raised-button
            data-tfa="recupererformations-porteuses-bouton-enregistrer"
            color="primary"
            [disabled]="recupererFormationsPorteusesForm.invalid"
            (click)="submitRecupererFormationsPorteuses()"
        >
            Récupérer
            <mat-icon iconPositionEnd data-tfa="icone-chevron-droite">chevron_right</mat-icon>
        </button>
        }
        <ng-template #submitButton2>
            <button
                mat-raised-button
                data-tfa="recupererformations-porteuses-bouton-annuler"
                color="accent"
                (click)="closeRecupererFormationsPorteusesDialog()"
            >
                Annuler
                <mat-icon iconPositionEnd data-tfa="icone-annuler">close</mat-icon>
            </button>
            <button
                mat-raised-button
                data-tfa="recupererformations-porteuses-bouton-enregistrer"
                color="primary"
                [disabled]="recupererFormationsPorteusesForm.invalid"
                (click)="submitRecupererFormationsPorteuses()"
            >
                Récupérer
                <mat-icon iconPositionEnd data-tfa="icone-chevron-droite">chevron_right</mat-icon>
            </button>
        </ng-template>
    </div>
</ng-template>
